/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map
